import { render, staticRenderFns } from "./ChangeOwnerComponent.vue?vue&type=template&id=43fbd82a&scoped=true&"
import script from "./ChangeOwnerComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeOwnerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOwnerComponent.vue?vue&type=style&index=0&id=43fbd82a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fbd82a",
  null
  
)

export default component.exports